import React from "react";
import { Container, Grid, Link } from "@mui/material";
import Heading from "../../components/Heading/heading";
import FeaturesCard from "./FeatureCard";

import doge from '../../image/doge.png'
import personDoge from '../../image/personDoge.png'
import certificates from '../../image/certificates.png'
import games from '../../image/games.png'

const Features = () => {
    return(
        <div id="features">
            <Container maxWidth="lg" className="py-5">
                <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                >
                    <Grid
                        xs={12}
                        className="text-center mb-5"
                    >
                        <Heading
                            subtitle="ShibaPup Features"
                            title="$ShibaPup Advantages"
                        />
                    </Grid>
                    
                    <Grid
                        xs={12}
                        sm={6}
                        md={4}
                        className="text-center d-md-none"
                    >
                        <FeaturesCard
                            img={doge}
                            title="Big Community"
                            subtitle="Big and long term projects deserve a big community."
                        />
                        <FeaturesCard
                            img={games}
                            title="Play to Earn"
                            subtitle="Score big and earn big by playing ShibaPup."
                        />
                    </Grid>

                    <Grid
                        xs={12}
                        sm={6}
                        md={4}
                        className="text-center d-none d-md-inline-block"
                    >
                        <FeaturesCard
                            img={doge}
                            title="Big Community"
                            subtitle="Big and long term projects deserve a big community."
                        />
                    </Grid>
                    <Grid
                        xs={12}
                        sm={6}
                        md={4}
                        className="text-center"
                    >
                        <FeaturesCard
                            img={personDoge}
                            title="Elon's Favorite Dog"
                            subtitle="Everyone knows the love story between Elon and Crypto dogs, especially Shiba."
                        />
                        <FeaturesCard
                            img={certificates}
                            title="Verified Contract"
                            subtitle="Contract is verified by Bscscan."
                        />
                    </Grid>
                    <Grid
                        xs={12}
                        sm={4}
                        className="text-center d-none d-md-inline-block"
                    >
                        <FeaturesCard
                            img={games}
                            title="Play to Earn"
                            subtitle="Score big and earn big by playing ShibaPup."
                        />
                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

export default Features;